"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TizenDeeplink = (function () {
    function TizenDeeplink(context) {
        var _this = this;
        this.context = context;
        this.deeplinkCallbacks = [];
        this.handleDeeplinkData();
        context.addEventListener('appcontrol', function () {
            _this.handleDeeplinkData();
        });
    }
    TizenDeeplink.prototype.onDeeplink = function (eventHandler) {
        this.deeplinkCallbacks.push(eventHandler);
    };
    TizenDeeplink.prototype.handleDeeplinkData = function () {
        var app = this.context.tizen && this.context.tizen.application;
        var currentApp = app && app.getCurrentApplication && app.getCurrentApplication();
        var requestedAppControl = currentApp && currentApp.getRequestedAppControl && currentApp.getRequestedAppControl();
        var data = requestedAppControl && requestedAppControl.appControl && requestedAppControl.appControl.data;
        if (data && data.length) {
            var _loop_1 = function (i) {
                if (data[i].key === 'PAYLOAD') {
                    var jsonObj = JSON.parse(data[i].value[0]);
                    var deeplinkData_1 = jsonObj.values;
                    this_1.data = deeplinkData_1;
                    this_1.deeplinkCallbacks.forEach(function (deeplinkCallback) { return deeplinkCallback(deeplinkData_1); });
                }
            };
            var this_1 = this;
            for (var i = 0; i < data.length; i++) {
                _loop_1(i);
            }
        }
    };
    return TizenDeeplink;
}());
exports.TizenDeeplink = TizenDeeplink;
